import React from "react";
import { NavLink, Outlet } from "react-router-dom";
import { IoIosArrowBack } from "react-icons/io";

const UpdateSellerLayOut = () => {
  return (
    <div className="mb-20 px-4 w-[80vw] ">
      <div className="border-b border-gray-300 py-7">
        <h1 className="md:text-2xl lg:text-3xl max-lg:text-4xl font-semibold text-[#667085]">
          Seller
        </h1>
      </div>{" "}
      <div className="mt-10">
        <h1 className="md:text-mg lg:text-lg w-fit max-lg:text-xl flex justify-start items-center cursor-pointer font-semibold text-[#667085]">
          <NavLink
            className={"flex justify-start items-center"}
            to={"/admin-dashboard/view-seller/"}
          >
            <IoIosArrowBack /> Seller Details
          </NavLink>
        </h1>
      </div>
      <Outlet />
    </div>
  );
};

export default UpdateSellerLayOut;